module.exports = __webpack_public_path__ + "img/arrow_backward_black.d37ad341.svg";